'use strict';

const init = () => {
    if (document.body.classList.contains('tc-website-reservationresume-document')) {
        sessionStorage.setItem('reservation', document.getElementById('reservation-data').dataset.reservation)
    } else if (!document.body.classList.contains('tc-website-balloonflightbooking')) {
        sessionStorage.removeItem('reservation')
    }
}

export default {init}
